import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "src/shared/api/base-query";
import { pagedQueryFn } from "src/shared/api/paged-query-fn";
import type { QuerySubscriptionOptions } from "src/shared/api/query-subscription-options";

import { IMeasure } from "../shared/interfaces/measure";

export const measuresApi = createApi({
  reducerPath: "measuresApi",
  baseQuery,
  endpoints: (builder) => ({
    fetchMeasuresWithDeleted: builder.query<IMeasure[], void>({
      queryFn: pagedQueryFn<IMeasure, IMeasure[]>(
        { url: "MeasuresV2", params: { includeDeleted: true } },
        (dtos) => dtos
      ),
    }),
  }),
});

const useMeasuresEndpoint = measuresApi.endpoints.fetchMeasuresWithDeleted.useQuery;

export function useFetchMeasuresWithDeleted(
  options?: QuerySubscriptionOptions<typeof useMeasuresEndpoint>
) {
  return useMeasuresEndpoint(undefined, options);
}
